import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';
export const actions = {
    SELECT_USER: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/SELECT_USER'),
    SELECT_ALL_USERS: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/SELECT_ALL_USERS'),
    UNSELECT_USER: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/UNSELECT_USER'),
    UNSELECT_ALL_USERS: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/UNSELECT_ALL_USERS'),
    UPDATE_SELECTED_USERS: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/UPDATE_SELECTED_USERS'),
    ADD_PAYMENT_USERS: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/ADD_PAYMENT_USERS'),
    DELETE_PAYMENT_USER: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/DELETE_PAYMENT_USER'),
    UPDATE_PAYMENT_USERS: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/UPDATE_PAYMENT_USERS'),
    CHANGE_UPGRADE_MODAL_VISIBILITY: createAction('ACCOUNTS/ORGANIZATION_PAYMENT/CHANGE_UPGRADE_MODAL_VISIBILITY'),
};
export const initialState = Map({
    selectedUsers: [],
    paymentUsers: [],
    isProcessing: false,
    upgradeModalVisible: false,
});
const reducer = handleActions({
    [actions.UPDATE_SELECTED_USERS]: (state, action) => state.set('selectedUsers', action.payload),
    [actions.UPDATE_PAYMENT_USERS]: (state, action) => state.set('paymentUsers', action.payload),
    [actions.CHANGE_UPGRADE_MODAL_VISIBILITY]: (state) => {
        if (window) {
            window.scrollTo({ top: 0 });
        }
        const isVisible = state.get('upgradeModalVisible');
        return state.set('upgradeModalVisible', !isVisible);
    },
}, initialState);
export default reducer;
